import Login from "./login";
import {useInjection} from "inversify-react";
import ApiService from "../../../services/apiService";
import {useAuth} from "oidc-react";
import {AuthenticationApi, LoginDto} from "../../../api";
import React from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { RoutingPaths } from "../../routing/routingContainer";


export default function LoginContainer() {

    const navigate = useNavigate();
    const auth = useAuth();
    const apiService = useInjection(ApiService);
    const [searchParams, _] = useSearchParams();

    // if (auth.userData) {
    //     return <Navigate to={RoutingPaths.mainPage.route} replace={true} />;
    // }
    
    const onLogin = async (value: any): Promise<any> => {
        try {
            const loginDto = {
                email: value.email,
                password: value.password,
                rememberMe: value.rememberMe
            } as LoginDto;
            await apiService.getApi(AuthenticationApi)
                .apiAuthenticationLoginPost("", loginDto)
                .then(response => {
                    const returnUrl = searchParams.get("ReturnUrl");

                    if (returnUrl) {
                        window.location.href = returnUrl;
                        return;
                    }

                    if (response.data as any === "/") {
                        navigate("/")
                    } else {
                        window.location.href = response.data as any;
                    }
                })
        } catch (e: any) {
            return "Niepoprawny login lub hasło.";
        }
    }

    const onForgotPassword = () => {
        navigate('/forgotPassword');
    }

    return <Login onForgotPassword={onForgotPassword} onLogin={onLogin}/>
}
